import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-infra',
  templateUrl: './infra.component.html',
  styleUrls: ['./infra.component.scss']
})
export class InfraComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
